import React, { useState, useCallback, createContext, useContext } from 'react';
import { C } from '../utils/styles';
import Icon from './Icon';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3000);
  }, []);

  const getIcon = (type) => {
    if (type === 'success') return 'checkmark-circle';
    if (type === 'error') return 'close-circle';
    return 'alert-circle';
  };

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 10000, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            padding: '10px 18px',
            borderRadius: 8,
            background: t.type === 'success' ? C.greenLight : t.type === 'error' ? C.redLight : C.orangeLight,
            color: t.type === 'success' ? C.green : t.type === 'error' ? C.red : C.orange,
            fontSize: 12,
            fontWeight: 700,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            border: `1px solid ${t.type === 'success' ? C.greenBorder : t.type === 'error' ? '#fca5a5' : '#fcd34d'}`,
            animation: 'slideIn 0.3s ease',
            fontFamily: "'Inter', sans-serif",
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}>
            <Icon name={getIcon(t.type)} style={{ fontSize: '16px' }} />
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
